import { render, staticRenderFns } from "./module3.vue?vue&type=template&id=67dc9ab8&scoped=true"
import script from "./module3.vue?vue&type=script&lang=js"
export * from "./module3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc9ab8",
  null
  
)

export default component.exports